<app-logged-out
  [noticeText]="noticeText"
  [isExternalUserWithoutAccount]="isExternalUserWithoutAccount"
  [isUserBlocked]="isUserBlocked"
></app-logged-out>
